import Layout from '../../components/Layout'

interface Props {
  team: { id: number; name: string; description: string | null; member_count: number }
  active_tab: string
}

export default function Announcements({ team, active_tab }: Props) {
  return (
    <Layout team={team} activeTab={active_tab}>
      <div className="max-w-screen-2xl mx-auto px-6 py-6">
        <h1 className="text-2xl font-semibold text-text-primary mb-6">Announcements</h1>
        <div className="bg-white rounded-lg border border-gray-200 p-12 text-center">
          <div className="text-text-muted mb-2">
            <svg className="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
            </svg>
          </div>
          <p className="text-text-secondary font-medium">Announcements coming soon</p>
          <p className="text-sm text-text-muted mt-1">Team announcements will appear here.</p>
        </div>
      </div>
    </Layout>
  )
}
